export const SHELL_KEYUP = 'SHELL_KEYUP';

export const GET_OUTPUT = 'GET_OUTPUT';
export const SET_OUTPUT = 'SET_OUTPUT';

export const GET_INPUT = 'GET_INPUT';
export const SET_INPUT = 'SET_INPUT';
